module.exports = __webpack_public_path__ + "static/media/C-Triads.4f6d47f2.png";